<template>
  <div
    :class="{ 'message--show': show }"
    class="message"
  >
    <!-- Close -->
    <div
      v-if="hasClose"
      class="message__close"
      @click="close"
    >
      <i class="icon-close"><span class="path1" /><span class="path2" /></i>
    </div>

    <!-- Icon -->
    <div class="message__icon">
      <i class="icon-bliss" />
    </div>

    <!-- Title -->
    <div class="message__title">
      <slot name="title" />
    </div>

    <!-- Message -->
    <div class="message__message">
      <slot name="message" />
    </div>

    <!-- Field -->
    <div class="message__field">
      <slot name="field" />
    </div>

    <!-- Action -->
    <div class="message__action">
      <slot name="action" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Message',

  props: {
    show: {
      type: Boolean,
      required: true
    },

    hasClose: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    close() {
      this.$emit('close-message');
    }
  }
};
</script>

<style lang="scss" src="@/assets/components/message/message-view.scss"></style>



// WEBPACK FOOTER //
// message-view.vue